import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./Whaybest.scss";
class Whaybest extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <section className="whaybest faq-bg">
        <div className="fadeIn" data-wow-offset={10} data-wow-duration="1.5s">
          <img
            className="faq-img"
            src="static/images/whaybest.jpg"
            data-src="static/images/whaybest.png"
            alt="none"
          />
          <div className="faq-line"> </div>
          <div className="faq-title about-us-faq">
            <FormattedMessage id="faq.a42" />
            <br /> <FormattedMessage id="faq.a43" />
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Whaybest)
);
